export default `uniform float uSize;
uniform float uPixelRatio;
uniform sampler2D uParticlesTexture;

attribute vec2 aParticlesUv;
attribute float aSize;

varying vec3 vColor;

void main() {
    vColor = color;

    vec4 particle = texture(uParticlesTexture, aParticlesUv);

    vec4 mvPosition = modelViewMatrix * vec4(particle.xyz, 1.0);
    gl_Position = projectionMatrix * mvPosition;

    
    float sizeIn = smoothstep(0.0, 0.1, particle.a);
    float sizeOut = 1.0 - smoothstep(0.7, 1.0, particle.a);
    float size = min(sizeIn, sizeOut);

    gl_PointSize = size * aSize * uSize * uPixelRatio * (300.0 / -mvPosition.z);
}`